import { render, staticRenderFns } from "./UserNotRegistered.vue?vue&type=template&id=2f0a6e98"
import script from "./UserNotRegistered.vue?vue&type=script&lang=js"
export * from "./UserNotRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports